import { memo } from "react";

const ActiveFilterIndicator = () => {
  return <div className={`h-[10px] w-[10px] rounded-full bg-red-400`} />;
};

export default memo(ActiveFilterIndicator);
